import React from "react";


import { Helmet } from 'react-helmet';
import { StoreProvider } from "./contexts";
import {  rootStore } from "./store";
import { BrowserRouter } from "react-router-dom";
import { config } from "./router";
import { renderRoutes } from "react-router-config";
import 'normalize.css';
import "./App.css"

function App() {
    return (
        <StoreProvider store={rootStore}>
                <React.Fragment>

                    <Helmet
                        titleTemplate="%s"
                        defaultTitle="restify.one"
                    />
                    <BrowserRouter>
                        {renderRoutes(config)}
                    </BrowserRouter>
                </React.Fragment>
        </StoreProvider>
    );
}

export default App
